<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="closeDialog()" @keydown.esc="closeDialog()" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-form ref="form" v-on:submit.prevent="importar($event)">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text style="margin-bottom: 80px">
            <v-row align="center" justify="center" class="mb-4 mt-4">
              <v-col md="10" class="elevation-1 pt-4 pb-4" style="background: #f5f5f5">
                <a-steps :current="step">
                  <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                </a-steps>
              </v-col>
            </v-row>

            <div class="steps-content">
              <!--step 0-->
              <v-row align="start" justify="center" v-if="step == 0" transition="fade-transition">
                <v-col md="6" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step0" class="form-step0-excel">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[0].title }}</b>
                      </p>
                    </div>
                    <v-label>
                      Descargar la plantilla de importación de políticas de reposición.
                      <v-label @click="downloadExcel" class="text-download font-weight-bold ms-1 me-1"> Descargar </v-label>
                    </v-label>

                    <v-alert type="info" density="compact" variant="tonal" class="mt-3">
                      Una política por fila. Si ya existe una política con el mismo Almacén, Cliente, Rubro y Subrubro se
                      <b>actualiza</b> con los valores del Excel; si no, se crea. Cliente vacío: aplica a todos los clientes. Subrubro vacío: todo el
                      rubro. Los campos opcionales vacíos toman su valor por defecto, que figura en el encabezado de cada columna y en la hoja
                      <b>Instrucciones</b> de la plantilla.
                    </v-alert>
                    <v-alert type="warning" density="compact" variant="tonal" class="mt-2">
                      Las listas de Subrubro y Tipo de ubicación dependen del Rubro y el Almacén de la fila: elegí esas dos primero. Si después
                      las cambiás, revisá el Subrubro y el Tipo de ubicación.
                    </v-alert>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excelFile"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>
                  </v-form>
                </v-col>
              </v-row>

              <!--step 1-->
              <v-row align="start" justify="center" v-if="step == 1" transition="fade-transition">
                <v-col md="10" class="mt-4 pr-0 pl-0">
                  <v-form ref="form_step1">
                    <div class="px-2 py-1 mb-3 bg-subtitle-section">
                      <p class="text-subtitle-1 mb-0">
                        <b>{{ steps[1].title }}</b>
                      </p>
                    </div>
                    <v-alert v-if="headers_mismatch" type="error" class="mb-3">
                      {{ headers_mismatch_msg }}
                    </v-alert>

                    <v-progress-linear v-if="!headers_mismatch" v-model="percent" color="blue-grey" style="height: 25px !important" class="mb-3 mt-3">
                      <strong>{{ Math.ceil(percent) || 0 }}%</strong>
                    </v-progress-linear>

                    <v-data-table v-if="!headers_mismatch" :headers="headers" :items="list_bulk" :search="search" :loading="loading_table" class="simple-table" :items-per-page="10" dense>
                      <template v-slot:item="{ item }">
                        <tr>
                          <td>{{ item.object.almacen_name }}</td>
                          <td>{{ item.object.client_username || "Todos" }}</td>
                          <td>{{ item.object.category_name }}</td>
                          <td>{{ item.object.subcategory_name || "Todos" }}</td>
                          <td>{{ item.object.tipo_ubicacion_name }}</td>
                          <td class="text-center">{{ showValue(item.object.min_days) }} / {{ showValue(item.object.max_days) }}</td>
                          <td class="text-center">{{ showValue(item.object.stock_min_default) }} / {{ showValue(item.object.stock_max_default) }}</td>
                          <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                          <td style="min-width: 200px" v-else-if="item.status == 1 && item.status_create">
                            <span class="text-green">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-else-if="item.msg != ''">
                            <span class="text-red">{{ item.msg }}</span>
                          </td>
                          <td style="min-width: 200px" v-else>Pendiente de procesado</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-form>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions style="position: fixed; bottom: 0; right: 0; left: 0">
            <v-row align="start" justify="center">
              <v-col cols="10" style="background-color: white">
                <v-btn @click="prev" color="blue-grey" variant="outlined" v-if="step > 0">Atras</v-btn>
                <div class="float-right mr-2" v-if="step == 1 && !headers_mismatch">
                  <v-chip color="success" class="mr-2">Creadas: {{ importaciones_creadas }}</v-chip>
                  <v-chip color="info" class="mr-2">Actualizadas: {{ importaciones_actualizadas }}</v-chip>
                  <v-chip color="error" class="">Fallidas: {{ importaciones_no_creadas }}</v-chip>
                  <v-btn v-if="importaciones_no_creadas > 0" @click="downloadErrorsExcel" color="error" variant="outlined" size="small" class="ml-3"> Descargar Errores </v-btn>
                </div>

                <v-btn class="float-right" variant="outlined" color="primary" @click="readExcel" v-if="step == 0" :disabled="excelFile == null && step == 0"> Siguiente</v-btn>
              </v-col>
              <v-col cols="12" style="background-color: #fafafa; border-top: 1px solid #c1c1c1" class="text-end">
                <v-btn color="error" text @click="closeDialog()">Cerrar</v-btn>
                <v-btn color="success" text type="submit" :disabled="submit_disabled || headers_mismatch" :loading="loading_create" v-if="step == 1">{{ formBtn }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import readXlsxFile from "read-excel-file";
import { POLITICA_REPOSICION_COLUMNS as COLS } from "@/constants/ExcelColumnMappings";

export default {
  mixins: [ValidMixin, ExportMixin],
  props: {
    service: Object,
    modal_title: String,
    formBtn: String,
    dialog: Boolean,
  },
  data() {
    return {
      step: 0,
      search: "",
      headers: [
        { title: "Almacén", align: "left", sortable: true, key: "object.almacen_name" },
        { title: "Cliente (username)", align: "left", sortable: true, key: "object.client_username" },
        { title: "Rubro", align: "left", sortable: true, key: "object.category_name" },
        { title: "Subrubro", align: "left", sortable: true, key: "object.subcategory_name" },
        { title: "Tipo de ubicación", align: "left", sortable: true, key: "object.tipo_ubicacion_name" },
        { title: "Cobertura mín / máx (días)", align: "center", sortable: false, key: "" },
        { title: "Defaults mín / máx", align: "center", sortable: false, key: "" },
        { title: "Resultado", align: "left", sortable: false, key: "msg" },
      ],
      steps: [{ title: "Importar Excel" }, { title: "Detalle del Excel" }],
      excelFile: null,
      list_bulk: [],
      loading_create: false,
      loading_table: false,
      submit_disabled: false,
      importaciones_creadas: 0,
      importaciones_actualizadas: 0,
      importaciones_no_creadas: 0,
      headers_mismatch: false,
      headers_mismatch_msg: "",
    };
  },
  computed: {
    percent: {
      get() {
        if (this.list_bulk.length == 0) return 0;
        return (this.list_bulk.filter((e) => e.status === 1).length * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },
  methods: {
    downloadExcel() {
      this.exportExcel(this.service.section + "/get-sample-excel", {}, "plantilla_politicas_reposicion.xlsx");
    },

    async readExcel() {
      this.step++;
      this.list_bulk = [];
      this.loading_table = true;
      this.headers_mismatch = false;
      this.headers_mismatch_msg = "";
      try {
        //sheet 1: la hoja de carga (la otra es la oculta con los datos de los desplegables)
        const rows = await readXlsxFile(this.excelFile, { sheet: 1 });

        const headersOk = await this.validateHeadersVersion(rows[0]);
        if (!headersOk) return;

        rows.slice(1).forEach((element, index) => {
          const raw = this.rawRow(element);
          //Excel suele traer filas en blanco al final del rango usado: se descartan
          if (raw.every((c) => c === "")) return;

          const object = this.parseObject(raw);
          this.list_bulk.push({
            object: object,
            //+2: una por el header y otra porque Excel numera desde 1
            msg: this.validateObject(object, index + 2),
            status: 0,
            status_create: false,
            loading: false,
          });
        });

        if (this.list_bulk.length == 0) this.toast.warning("El Excel no tiene filas para importar");
      } catch (error) {
        console.error(error);
        this.toast.error("Error al leer el archivo Excel");
      } finally {
        this.loading_table = false;
      }
    },

    async validateHeadersVersion(uploadedHeadersRow) {
      try {
        const response = await this.service.get_excel_headers_version();
        const expectedHeaders = response.result.headers;
        const uploaded = uploadedHeadersRow || [];
        for (let i = 0; i < expectedHeaders.length; i++) {
          const expectedValue = (expectedHeaders[i] || "").toString().trim();
          const uploadedValue = uploaded[i] != null ? uploaded[i].toString().trim() : "";
          if (expectedValue !== uploadedValue) {
            this.headers_mismatch = true;
            this.headers_mismatch_msg = "El archivo no corresponde a la última versión del sistema. Por favor descargue nuevamente la plantilla actualizada.";
            return false;
          }
        }
        return true;
      } catch (error) {
        console.error(error);
        this.headers_mismatch = true;
        this.headers_mismatch_msg = "No se pudo verificar la versión del Excel. Intente nuevamente.";
        return false;
      }
    },

    //Las celdas de la fila como texto, columnas A a M
    rawRow(element) {
      const raw = [];
      for (let i = 0; i <= COLS.ACTIVA; i++) raw.push(this.cellToString(element[i]));
      return raw;
    },

    parseObject(raw) {
      return {
        almacen_name: raw[COLS.ALMACEN],
        client_username: raw[COLS.CLIENTE_USERNAME],
        category_name: raw[COLS.CATEGORIA],
        subcategory_name: raw[COLS.SUBCATEGORIA],
        tipo_ubicacion_name: raw[COLS.TIPO_UBICACION],
        min_days: this.textToNumber(raw[COLS.MIN_DAYS]),
        max_days: this.textToNumber(raw[COLS.MAX_DAYS]),
        back_period_days: this.textToNumber(raw[COLS.BACK_PERIOD_DAYS]),
        stock_min_default: this.textToNumber(raw[COLS.STOCK_MIN_DEFAULT]),
        stock_max_default: this.textToNumber(raw[COLS.STOCK_MAX_DEFAULT]),
        factor_llenado: this.textToNumber(raw[COLS.FACTOR_LLENADO]),
        umbral_cambio_pct: this.textToNumber(raw[COLS.UMBRAL_CAMBIO_PCT]),
        redondear_a_caja: this.textToSiNo(raw[COLS.REDONDEAR_A_CAJA]),
        activo: this.textToSiNo(raw[COLS.ACTIVA]),
        //Para el Excel de errores: lo que el usuario escribio, aunque no sea un valor valido
        raw: raw,
      };
    },

    /**
     * Lo que se puede detectar sin ir al backend. Las filas con error no se mandan, pero cuentan
     * como fallidas y van al Excel de errores. Devuelve el mensaje, o "" si la fila esta bien.
     */
    validateObject(o, excel_row) {
      const fila = "Fila " + excel_row + ": ";
      const esNumero = (v) => v !== null && !Number.isNaN(v);
      if (o.almacen_name === "") return fila + "falta el almacén.";
      if (o.category_name === "") return fila + "falta el rubro.";
      if (o.tipo_ubicacion_name === "") return fila + "falta el tipo de ubicación.";
      if (!esNumero(o.min_days) || o.min_days < 0) return fila + "los días de cobertura del mínimo deben ser un número mayor o igual a 0.";
      if (!esNumero(o.max_days) || o.max_days <= o.min_days) return fila + "los días de cobertura del máximo deben ser un número mayor a los del mínimo.";
      if (!Number.isInteger(o.stock_min_default) || o.stock_min_default < 0) return fila + "el stock mínimo por defecto debe ser un entero mayor o igual a 0.";
      if (!Number.isInteger(o.stock_max_default) || o.stock_max_default <= o.stock_min_default) return fila + "el stock máximo por defecto debe ser un entero mayor al mínimo.";
      if (o.back_period_days !== null && (!Number.isInteger(o.back_period_days) || o.back_period_days < 1)) return fila + "la ventana de historia debe ser un entero mayor a 0.";
      if (o.factor_llenado !== null && (Number.isNaN(o.factor_llenado) || o.factor_llenado <= 0 || o.factor_llenado > 1)) return fila + "el factor de llenado debe estar entre 0 y 1.";
      if (o.umbral_cambio_pct !== null && (Number.isNaN(o.umbral_cambio_pct) || o.umbral_cambio_pct < 0 || o.umbral_cambio_pct > 100)) return fila + "el umbral de cambio debe estar entre 0 y 100.";
      if (o.redondear_a_caja === undefined) return fila + "Redondear a caja debe ser SI o NO.";
      if (o.activo === undefined) return fila + "Activa debe ser SI o NO.";
      return "";
    },

    cellToString(value) {
      if (value === null || value === undefined) return "";
      return value.toString().trim();
    },

    //null = vacio, NaN = no es un numero. Acepta coma decimal ("0,85")
    textToNumber(text) {
      if (text === "") return null;
      return Number(text.replace(",", "."));
    },

    //null = vacio (el backend lo toma como SI), undefined = valor invalido
    textToSiNo(text) {
      const value = text.toUpperCase();
      if (value === "") return null;
      if (value === "SI" || value === "SÍ") return true;
      if (value === "NO") return false;
      return undefined;
    },

    showValue(value) {
      return value === null || Number.isNaN(value) ? "-" : value;
    },

    closeDialog() {
      this.$emit("updateDialog", false);
      this.resetForm();
    },

    resetForm() {
      this.step = 0;
      this.list_bulk = [];
      this.excelFile = null;
      this.importaciones_creadas = 0;
      this.importaciones_actualizadas = 0;
      this.importaciones_no_creadas = 0;
      this.submit_disabled = false;
      this.loading_create = false;
      this.loading_table = false;
      this.headers_mismatch = false;
      this.headers_mismatch_msg = "";
    },

    prev() {
      this.step--;
    },

    async importar() {
      this.loading_create = true;
      this.submit_disabled = true;

      for (let index = 0; index < this.list_bulk.length; index++) {
        const row = this.list_bulk[index];
        if (row.status != 0) continue;

        //Filas que ya fallaron al leer el Excel: no se mandan, pero cuentan como fallidas
        if (row.msg != "") {
          row.status = 1;
          row.status_create = false;
          this.importaciones_no_creadas++;
          continue;
        }

        row.loading = true;
        const result = await this.createItem(row.object);
        row.loading = false;
        row.status = 1;
        row.status_create = result.status;
        row.msg = result.msg;

        if (!result.status) this.importaciones_no_creadas++;
        else if (result.accion === "actualizada") this.importaciones_actualizadas++;
        else this.importaciones_creadas++;
      }

      this.loading_create = false;

      //Algo se creo o actualizo: la lista de atras tiene que reflejarlo aunque haya fallidas
      if (this.importaciones_creadas + this.importaciones_actualizadas > 0) this.$emit("loadList");

      if (this.importaciones_no_creadas === 0) {
        this.toast.success("Importación finalizada: " + this.importaciones_creadas + " creadas, " + this.importaciones_actualizadas + " actualizadas.");
        this.closeDialog();
      }
    },

    async createItem(o) {
      try {
        const response = await this.service.import_line_excel({
          almacen_name: o.almacen_name,
          client_username: o.client_username !== "" ? o.client_username : null,
          category_name: o.category_name,
          subcategory_name: o.subcategory_name !== "" ? o.subcategory_name : null,
          tipo_ubicacion_name: o.tipo_ubicacion_name,
          min_days: o.min_days,
          max_days: o.max_days,
          back_period_days: o.back_period_days,
          stock_min_default: o.stock_min_default,
          stock_max_default: o.stock_max_default,
          factor_llenado: o.factor_llenado,
          umbral_cambio_pct: o.umbral_cambio_pct,
          redondear_a_caja: o.redondear_a_caja,
          activo: o.activo,
        });
        return {
          status: response.status,
          accion: response.result ? response.result.accion : null,
          msg: response.msg || (response.status ? "Importación exitosa" : "Error en la importación"),
        };
      } catch (error) {
        return {
          status: false,
          accion: null,
          msg: error.response?.data?.msg || error.message || "Error en la importación",
        };
      }
    },

    downloadErrorsExcel() {
      const errorsData = this.list_bulk.filter((item) => item.status === 1 && !item.status_create && item.msg !== "");
      if (errorsData.length === 0) {
        this.toast.warning("No hay errores para exportar");
        return;
      }

      //Se manda el texto crudo de cada celda: si el error es "no es un numero" o "Activa debe ser
      //SI o NO", el Excel de errores tiene que mostrar lo que el usuario escribio, no un vacio
      const formattedErrors = errorsData.map((item) => {
        const r = item.object.raw;
        return {
          object: {
            almacen_name: r[COLS.ALMACEN],
            client_username: r[COLS.CLIENTE_USERNAME],
            category_name: r[COLS.CATEGORIA],
            subcategory_name: r[COLS.SUBCATEGORIA],
            tipo_ubicacion_name: r[COLS.TIPO_UBICACION],
            min_days: r[COLS.MIN_DAYS],
            max_days: r[COLS.MAX_DAYS],
            back_period_days: r[COLS.BACK_PERIOD_DAYS],
            stock_min_default: r[COLS.STOCK_MIN_DEFAULT],
            stock_max_default: r[COLS.STOCK_MAX_DEFAULT],
            factor_llenado: r[COLS.FACTOR_LLENADO],
            umbral_cambio_pct: r[COLS.UMBRAL_CAMBIO_PCT],
            redondear_a_caja: r[COLS.REDONDEAR_A_CAJA],
            activo: r[COLS.ACTIVA],
          },
          msg: item.msg,
        };
      });

      this.exportExcel(this.service.section + "/get-excel-with-errors", { errors_data: formattedErrors }, "errores_importacion_politicas_reposicion.xlsx");
    },
  },
};
</script>
